import RoutingPage from "./bodyComponent/RoutingPage";
import App from "./App";
import Summary from "./bodyComponent/Summary";
import SelfIntroduction from "./bodyComponent/Summary/selfIntroduction";
import Projects from "./bodyComponent/Summary/projects";
import Others from "./bodyComponent/Summary/others";
import AllSummary from "./bodyComponent/Summary/allSummary";
import {getConstantVersion} from "./util/util";

let routes = [];

// 버전에 따라 path 분기
if (getConstantVersion() === 1) {
    routes = [
        {
            path: '/',
            element: <App/>,
        },
        {
            path: '/',
            element: <Summary/>,
        },
        {
            path: '/self-introduction',
            element: <SelfIntroduction/>,
        },
        {
            path: '/projects',
            element: <Projects/>,
        },
        {
            path: '/others',
            element: <Others/>,
        },
        {
            path: 'all',
            element: <AllSummary/>
        },
        {
            path: '/route-test',
            element: <RoutingPage />,
        }
    ];
}
if (getConstantVersion() === 2) {
    routes = [
        {
            path: '/',
            element: <App/>,
        }
    ];
}

export default routes;